import { PostServiceM3 } from "../../ConexionSQL/posts.service";

export class cuponesService {

    /**
     * Obtiene todos los cupones generados por un proceso
     * @param PostServiceM3 
     * @param idkatios 
     * @param data 
     * @param funcionOK 
     * @param funcionError 
     */
    public m3_get_cupones_generados_by_proceso(PostServiceM3: PostServiceM3, idkatios: string, data: any,
        funcionOK: Function, funcionError: Function) {
        
        //var data = { "id_m3": idm3, "id_proceso": proceso };
        PostServiceM3.getWithBodyM3("M3/m3_get_cupones_generados_by_proceso/" + idkatios, data).subscribe(resp => {
          var cupones = JSON.parse(resp.toString());
          var resp_cupones:Array<any>;
          if(!cupones.CUPONES.CUPON.length){
            resp_cupones = new Array<any>();
            resp_cupones.push(cupones.CUPONES.CUPON);
          }else{
            resp_cupones = cupones.CUPONES.CUPON;
          }
          
          funcionOK(resp_cupones);
        },
          err => {
            funcionError(err.error.Message);
          });
      }
      
      public getCuponByIdDet(PostServiceM3: PostServiceM3, idkatios: string, data: any,
        funcionOK: Function, funcionError: Function) {
    
        //var data = { "idDetCupon": idDetCupon};
        PostServiceM3.getWithBodyM3("M3/getCuponByIdDet/" + idkatios, data).subscribe(resp => {
          funcionOK(resp);
        },
          err => {
            funcionError(err);
          });
      }
}